import { createFileRoute } from '@tanstack/react-router';
import { TrashPage } from '@/features/debts/trash-page.js';

export const Route = createFileRoute('/_app/trash')({
  component: TrashPage,
});
